import { useStaticQuery, graphql } from "gatsby"

const mainNavQuery = graphql`query MainNavQuery {
  allCraftMainNavNode(sort: {lft: ASC}, filter: {level: {eq: 1}}) {
    nodes {
      uid
      title
      nodeUri
      newWindow
      type
      element {
        ... on Craft_EntryInterface {
          uid
        }
      }
    }
  }
  allCraftEntryInterface(filter: {sectionHandle: {eq: "pages"}}) {
    nodes {
      uid
      title
      uri
      level
      typeHandle
      ancestors {
        uid
        level
      }
    }
  }
}`

const getNestedChildren = (arr, parentUid) => {
  return arr
    ?.filter(({ ancestors, level }) => {
      return (
        ancestors.length > 0 &&
        ancestors.filter(
          (ancestor) =>
            ancestor.uid === parentUid && ancestor.level === level - 1
        ).length > 0
        // && ancestors[0]?.level === level - 1
      )
    })
    .map((node) => {
      return {
        ...node,
        descendants: getNestedChildren(arr, node.uid),
      }
    })
}

/**
 * Get Craft's mainNav top level data, with nested entries
 */
export const useMainNav = () => {
  const { allCraftMainNavNode, allCraftEntryInterface } =
    useStaticQuery(mainNavQuery)

  const mainNav = allCraftMainNavNode?.nodes?.map((node) => {
    if (node?.element?.uid) {
      const { uid } = node.element
      const descendants = getNestedChildren(allCraftEntryInterface?.nodes, uid)

      return {
        ...node,
        descendants,
      }
    }

    return node
  })

  return mainNav
}
